import React from 'react';
import { FormHelperText } from '@material-ui/core';
import classNames from 'clsx';

import { Alert } from 'app/components/Alert';
import { FormsEnum, MessageTypeEnum } from 'app/shared/enums';
import { ControlContainerProps } from './ControlContainer.interfaces';
import { FormTooltip } from 'app/components/FormTooltip';
import { InputLabel } from 'app/components/InputLabel';
import { SubLabel } from 'app/components/SubLabel';
import { HoverTooltip } from 'app/components/HoverTooltip';
import { useStyles } from './ControlContainer.styles';

const ControlContainer = (props: ControlContainerProps) => {
  const {
    children,
    tooltip,
    tooltipIcon,
    floating,
    floated,
    label,
    subLabel,
    filled,
    meta,
    className,
    disabled,
    width = 'md',
    focused,
    hoverTooltipText,
    tipMessage,
    defaultAlertStyle,
    helperText,
    bottomTipMessage,
    inputId,
    withoutHtmlFor,
    isPaymentMethodOnInstallmentsActive,
    formName,
  } = props;

  const classes = useStyles(props);

  const isNewPaymentControlStyleActive =
    isPaymentMethodOnInstallmentsActive &&
    formName === FormsEnum.CheckoutPaymentForm;

  return (
    <>
      {tipMessage && <div className={classes.message}>{tipMessage}</div>}
      {(label || subLabel) && (
        <InputLabel
          floated={floated}
          floating={floating}
          filled={filled}
          className={classes.label}
          disabled={!!disabled}
          error={meta && meta.touched && !meta.valid}
          focused={focused}
          withoutHtmlFor={withoutHtmlFor}
          inputId={inputId || ''}
        >
          {label}
          {label && subLabel && ' '}
          {subLabel && <SubLabel floated={floated}>{subLabel}</SubLabel>}
          <FormTooltip
            content={tooltip}
            icon={tooltipIcon}
            className={classNames('tooltip', classes.tooltip)}
            inputId={inputId}
          />
        </InputLabel>
      )}
      <div className={classes.withBulb}>
        <div className={classNames(className, classes.root)}>
          <div
            className={classNames(
              classes.controlAndLabelWrapper,
              classes[width],
              {
                [classes.newStyleControlAndLabelWrapper]: isNewPaymentControlStyleActive,
              }
            )}
            role="group"
            aria-labelledby={label ? `${inputId}-label` : undefined}
          >
            {hoverTooltipText ? (
              <HoverTooltip hoverTooltipText={hoverTooltipText}>
                {children}
              </HoverTooltip>
            ) : (
              <div className={classes.controlWrapper}>{children}</div>
            )}
          </div>

          {!(label || subLabel) && (
            <FormTooltip
              content={tooltip}
              icon={tooltipIcon}
              className={classNames('tooltip', classes.tooltip)}
              inputId={inputId}
            />
          )}
        </div>
      </div>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {bottomTipMessage && (
        <div className={classes.bottomTipMessage}>{bottomTipMessage}</div>
      )}
      {meta && meta.touched && meta.error && (
        <Alert
          icon={false}
          text={meta.error}
          type={MessageTypeEnum.Danger}
          className={classNames(
            {
              [classes.compactAlert]: !defaultAlertStyle,
            },
            classes.alert
          )}
        />
      )}
    </>
  );
};

export default ControlContainer;
